import React from "react";
import CloseButton from "@components/FlowActionButtons/CloseButton";
import { canUserClose } from "./utils";

interface CloseMovementProps {
  movementFlowData?: {
    id: string;
    task: { status: string; claimOwnerName: string } | null;
    status: string;
    terminalReport: { report: string } | null;
    to: string;
    from: string;
  };
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "vessel-call.movement-services";

const CloseMovement: React.FC<CloseMovementProps> = ({ movementFlowData, openDrawer }) => {
  if (!movementFlowData) {
    return null;
  }

  if (!movementFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserClose(
    movementFlowData.task.status,
    movementFlowData.task.claimOwnerName,
    movementFlowData.status,
  );
  const handleCloseClick = () => {
    openDrawer("closeDrawer");
  };
  return (
    <CloseButton
      langBase={LANG_BASE}
      permission="canCloseMovementService"
      isActionAvailable={isActionAvailable}
      onClose={handleCloseClick}
    />
  );
};
export default CloseMovement;
